module.exports = __webpack_public_path__ + "img/172.8a3845eb.png";